import { render, staticRenderFns } from "./EmailCampaignsTable.vue?vue&type=template&id=670df04b&scoped=true&"
import script from "./EmailCampaignsTable.vue?vue&type=script&lang=ts&"
export * from "./EmailCampaignsTable.vue?vue&type=script&lang=ts&"
import style0 from "./EmailCampaignsTable.vue?vue&type=style&index=0&id=670df04b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670df04b",
  null
  
)

export default component.exports
import {QTable,QTr,QTh,QIcon,QTd,QInput,QBtn} from 'quasar'
component.options.components = Object.assign({QTable,QTr,QTh,QIcon,QTd,QInput,QBtn}, component.options.components || {})
